const textFieldModalPlaces = {
  name: 'Nome',
  childLabel: 'Tipo do Ramo',
  helperText: 'Ex.: site, department, sala, galpão, ...',
  latitude: 'Latitude',
  longitude: 'Longitude'
};

export default textFieldModalPlaces;
